@if (tenant?.enabled_features?.new_onboarding) {
  @if (!isUserLoggedIn) {
    @if (error?.status) {
      <div
        [ngStyle]="{ 'max-width': '400px', width: '95vw' }"
        class="color-orange u-margin-center"
      >
        <div fxLayout="row" fxLayoutAlign="start center">
          <mat-icon
            class="color-orange md-36"
            fxFlex="52px"
            fxLayoutAlign="start center"
          >
            error
          </mat-icon>
          <div i18n="@@loginView.linkExpiredError" fxFlex="100%">
            It seems like the link you tried to use is either invalid or
            expired. Request a new login link to access your account.
          </div>
        </div>
      </div>
    }
    @if (isLoggingIn) {
      <div
        [ngStyle]="{ 'max-width': '400px', width: '95vw' }"
        class="u-margin-center"
      >
        <div fxLayout="row" fxLayoutAlign="start center">
          <div fxFlex="52px" fxLayout="row" fxLayoutAlign="start center">
            <app-progress-spinner class="u-display-block" />
          </div>
          <div i18n="@@loginView.verifying" fxFlex="100%">Verifying...</div>
        </div>
      </div>
    }
    @if (!authService.$isLoggedIn()) {
      @switch (viewMode) {
        @case (VIEW_MODES.enterEmail) {
          @if (showSSOButton) {
            <div
              class="u-width-100 u-height-100"
              fxLayout="column"
              fxLayoutAlign="space-between center"
            >
              <div class="u-width-100">
                <app-sso-signin
                  [ssoErrorMessage]="ssoErrorMessage"
                  [ssoErrorStatus]="+ssoErrorStatus"
                  [ssoSignInParams]="ssoSignInParams"
                  [tenant]="tenant"
                  (authWithEmailClicked)="signInWithEmailHandler()"
                  class="u-display-block u-width-100 u-marginTop-40"
                />
                <ng-container *ngTemplateOutlet="signupLink" />
              </div>
              <ng-container [ngTemplateOutlet]="loginPolicies" />
            </div>
          } @else {
            <div
              class="u-width-100 u-height-100"
              fxLayout="column"
              fxLayoutAlign="center center"
            >
              <p
                class="u-marginBottom-32 u-marginTop-8 u-textDecoration-bold text-body-lg"
                i18n="@@loginView.enterEmailView.emailLoginPrompt"
              >
                We'll send you a link to access your profile.
              </p>
              <div class="u-width-100 u-height-100" fxLayoutAlign="center">
                <form
                  [formGroup]="loginForm"
                  (ngSubmit)="sendEmail(loginForm)"
                  class="u-width-100"
                  fxFlex="1 1 auto"
                  fxLayout="column"
                  fxLayoutAlign="space-between center"
                  novalidate
                  nz-form
                  nzLayout="vertical"
                >
                  <div
                    class="u-width-100"
                    fxLayout="column"
                    fxLayoutAlign="start center"
                    fxLayoutGap="32px"
                  >
                    <nz-form-item
                      [ngStyle]="{ 'max-width': '500px' }"
                      class="u-width-100"
                    >
                      <nz-form-label i18n="@@global.email" nzRequired
                        >Email</nz-form-label
                      >
                      <nz-form-control [nzErrorTip]="emailErrorTip">
                        <input
                          [ngStyle]="{ height: '40px' }"
                          autocomplete="off"
                          formControlName="email"
                          nz-input
                          required
                          type="email"
                        />
                      </nz-form-control>
                      <ng-template #emailErrorTip>
                        @if (loginForm?.get('email').errors?.server) {
                          <p
                            class="text-caption color-orange u-wordWrap-breakWord"
                          >
                            <ng-container
                              i18n="@@loginView.enterEmailView.serverError"
                              >{loginForm?.get('email')?.errors?.server, select,
                                other {
                                  {{ loginForm?.get('email')?.errors?.server }}
                                }

                            }</ng-container>
                          </p>
                        } @else {
                          <div i18n="@@loginView.emailErrorTip">
                            Please enter a valid email
                          </div>
                        }
                      </ng-template>
                    </nz-form-item>
                    <ng-container *ngTemplateOutlet="signupLink" />
                  </div>
                  <div class="u-width-100">
                    <div class="u-marginBottom-medium">
                      <ng-container *ngTemplateOutlet="loginPolicies" />
                    </div>
                    <div
                      [fxLayoutAlign]="
                        tenantHasSSOEnabled ? 'space-between end' : 'end end'
                      "
                      class="u-width-100"
                      fxLayout="row"
                    >
                      @if (tenantHasSSOEnabled) {
                        <button
                          (click)="showSSOButton = true"
                          fxLayoutAlign="center center"
                          mat-stroked-button
                          type="button"
                        >
                          <span i18n="@@global.back">Back</span>
                        </button>
                      }
                      <button
                        [disabled]="
                          isLoading || !loginForm.valid || isLoggingIn
                        "
                        color="primary"
                        mat-flat-button
                        type="submit"
                      >
                        <div fxLayoutAlign="center center" fxLayoutGap="8px">
                          @if (isLoading) {
                            <i
                              nz-icon
                              nzSpin
                              nzTheme="outline"
                              nzType="sync"
                            ></i>
                          }
                          <span i18n="@@loginView.sendLinkCta">
                            Send Link
                          </span>
                        </div>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          }
        }
        @case (VIEW_MODES.emailSent) {
          <div
            class="u-width-100 u-height-100"
            fxLayout="column"
            fxLayoutAlign="center center"
          >
            <h6
              class="u-paddingBottom-16 u-marginTop-32 text-body-lg u-textDecoration-bold"
              i18n="@@loginView.emailSentView.linkSentTitle"
            >
              We've sent a link to your email
            </h6>

            <p
              class="color-grey-300 u-wordWrap-breakWord"
              i18n="@@loginView.emailSentView.linkSentText"
            >
              The link sent to
              <span class="color-black">{{ loginForm.value.email }}</span>
              will expire in 60 minutes.
            </p>
            <p
              class="u-marginBottom-16 color-grey-300"
              i18n="@@loginView.emailSentView.tryAgainPrompt"
            >
              If you didn't get the email, select the button below to try again.
            </p>
            <div class="u-width-100 u-height-100" fxLayoutAlign="end end">
              <button
                (click)="reset()"
                color="primary"
                fxLayoutAlign="center center"
                mat-raised-button
              >
                <ng-container i18n="@@global.tryAgain">
                  Try again
                </ng-container>
              </button>
            </div>
          </div>
        }
      }
    }
  }
  <ng-template #loginPolicies>
    <div class="color-grey text-caption u-textAlign-center">
      <p i18n="@@loginView.reCAPTCHADisclaimer">
        This site is protected by reCAPTCHA.
      </p>
      <p i18n="@@loginView.googlePrivacyDisclaimer">
        The Google
        <a class="color-blue" href="https://policies.google.com/privacy"
          >Privacy Policy</a
        >
        and
        <a class="color-blue" href="https://policies.google.com/terms"
          >Terms of Service</a
        >
        apply.
      </p>
    </div>
  </ng-template>
  <ng-template #signupLink>
    @if (canSignup) {
      <p
        [ngStyle]="{ 'font-size': showSSOButton ? '18px' : '' }"
        class="u-textAlign-center color-text-subdued text-body-lg"
        i18n="@@loginView.signupPrompt"
      >
        Don't have an account?
        <a [routerLink]="['/signup']" class="color-blue c-button"> Sign up </a>
      </p>
    }
  </ng-template>
} @else {
  @if (!isUserLoggedIn) {
    @if (error?.status) {
      <div
        [ngStyle]="{ 'max-width': '400px', width: '95vw' }"
        class="color-orange u-margin-center"
      >
        <div fxLayout="row" fxLayoutAlign="start center">
          <mat-icon
            class="color-orange md-36"
            fxFlex="52px"
            fxLayoutAlign="start center"
          >
            error
          </mat-icon>
          <div i18n="@@loginView.linkExpiredError" fxFlex="100%">
            It seems like the link you tried to use is either invalid or
            expired. Request a new login link to access your account.
          </div>
        </div>
      </div>
    }
    @if (isLoggingIn) {
      <div
        [ngStyle]="{ 'max-width': '400px', width: '95vw' }"
        class="u-margin-center"
      >
        <div fxLayout="row" fxLayoutAlign="start center">
          <div fxFlex="52px" fxLayout="row" fxLayoutAlign="start center">
            <app-progress-spinner class="u-display-block" />
          </div>
          <div i18n="@@loginView.verifying" fxFlex="100%">Verifying...</div>
        </div>
      </div>
    }
    @if (!authService.$isLoggedIn()) {
      <div
        [ngStyle]="{ 'max-width': '400px', width: '95vw' }"
        class="bg-color-white u-card u-margin-center u-marginTop-24 u-padding-24 mat-elevation-z1"
      >
        @switch (viewMode) {
          @case (VIEW_MODES.enterEmail) {
            <div
              class="u-marginBottom-24"
              fxLayout="row"
              fxLayoutAlign="start center"
            >
              @if (tenant) {
                <app-avatar-tenant
                  [item]="tenant"
                  [size]="96"
                  class="u-display-block"
                >
                </app-avatar-tenant>
              }
            </div>
            <h6
              i18n="@@loginView.enterEmailView.title"
              class="u-paddingBottom-16"
              fxLayout="row"
              fxLayoutAlign="start center"
            >
              Log in
              @if (tenant?.friendly_name) {
                to {{ tenant?.friendly_name }}
              }
            </h6>
            @if (showSSOButton) {
              <app-sso-signin
                [ssoErrorMessage]="ssoErrorMessage"
                [ssoErrorStatus]="+ssoErrorStatus"
                [ssoSignInParams]="ssoSignInParams"
                [tenant]="tenant"
                class="u-display-block"
              />
              @if (tenant.email_login_enabled) {
                <p
                  i18n="@@loginView.enterEmailView.loginWithEmailPrompt"
                  class="color-grey-300 u-marginTop-8"
                >
                  Or,
                  <button
                    (click)="showSSOButton = false"
                    class="c-button color-blue"
                    type="button"
                  >
                    use a magic link via your email address</button
                  >.
                </p>
              }
            } @else {
              <p
                i18n="@@loginView.enterEmailView.loginPrompt"
                class="u-marginBottom-16 color-grey-300"
              >
                Enter your email and we'll send you a link to access your
                profile.
              </p>
              <form
                [formGroup]="loginForm"
                (ngSubmit)="sendEmail(loginForm)"
                novalidate
              >
                <div class="u-marginBottom-8">
                  <mat-form-field class="mat-form-field-width-100">
                    <mat-label i18n="@@global.email">Email</mat-label>
                    <input
                      autocomplete="off"
                      formControlName="email"
                      matInput
                      required
                      type="email"
                    />
                    @if (isLoading) {
                      <app-progress-spinner
                        class="u-display-block u-marginRight-16"
                        matSuffix
                      />
                    }
                  </mat-form-field>
                  @if (loginForm?.get('email')?.errors?.server) {
                    <p class="text-caption color-orange u-wordWrap-breakWord">
                      <ng-container
                        i18n="@@loginView.enterEmailView.serverError"
                        >{loginForm?.get('email')?.errors?.server, select,
                          other {{{ loginForm?.get('email')?.errors?.server }} }

                      }</ng-container>
                    </p>
                  }
                </div>
                <div
                  class="u-paddingBottom-24"
                  fxLayout="row"
                  fxLayoutAlign="start center"
                >
                  <button
                    i18n="@@loginView.enterEmailView.sendCta"
                    [disabled]="isLoading || !loginForm.valid || isLoggingIn"
                    color="primary"
                    mat-raised-button
                    type="submit"
                  >
                    Send Link
                  </button>
                </div>
              </form>
              @if (tenantHasSSOEnabled) {
                <p
                  i18n="@@loginView.enterEmailView.loginWithSSOPrompt"
                  class="color-grey-300"
                >
                  Or,
                  <button
                    (click)="showSSOButton = true"
                    class="c-button color-blue"
                    type="button"
                  >
                    use your team's Single sign-on authentication</button
                  >.
                </p>
              }
            }
          }
          @case (VIEW_MODES.emailSent) {
            <div
              class="u-marginBottom-24"
              fxLayout="row"
              fxLayoutAlign="start center"
            >
              @if (tenant) {
                <app-avatar-tenant
                  [item]="tenant"
                  [size]="96"
                  class="u-display-block"
                />
              }
            </div>
            <h6
              i18n="@@loginView.emailSentView.title"
              class="u-paddingBottom-16"
            >
              Check your email!
            </h6>
            <p
              i18n="@@loginView.emailSentView.linkSentText"
              class="u-marginBottom-16 color-grey-300 u-wordWrap-breakWord"
            >
              The link sent to
              <span class="color-black">{{ loginForm.value.email }}</span> will
              expire in 60 minutes.
            </p>
            <p
              i18n="@@loginView.emailSentView.sendLinkPrompt"
              class="u-marginBottom-16 color-grey-300"
            >
              If you didn't get the email, select the button below to try a new
              address.
            </p>
            <div
              class="u-padding-0-16 u-paddingBottom-16"
              fxLayout="row"
              fxLayoutAlign="end center"
            >
              <button (click)="reset()" color="primary" mat-raised-button>
                <ng-container i18n="@@global.tryAgain">
                  Try again
                </ng-container>
              </button>
            </div>
          }
        }
      </div>
    }
  }
}
<ng-template #createAccountErrorTemplate>
  <p i18n="@@confirmPromptDialog.content.createAccount">
    We didn't find an account for <b>{{ loginForm.value.email }}</b
    >. Did you mean to create an account instead?
  </p>
</ng-template>
